<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-05-31 16:34:27
-->
<template>
  <div class="account-component" id="account-contentWrapper" style="min-width: 1000px;height:100%;min-height: 500px;">
    

    <!-- empty palce holder -->
    <div id="filler" :style="{width:'100px',height:'100%'}"></div>

    <div
      class="container body-content"
      style="position: relative;  z-index: 0; height:calc(100%)"
    >
      <router-view></router-view>
    </div>

    <!-- foot -->
    <!-- <ve-layout-foot></ve-layout-foot> -->
  </div>
</template>

<script>
import FootPart from "./components/Foot";

const headerAndFootUsedHeight = 134;
export default {
  data() {
    return {
      parts: []
    };
  },
  watch: {
    $route() {
      this.getLocationParts();
    }
  },
  components: {
    "ve-layout-foot": FootPart
  },
  methods: {
    getLocationParts() {
      let matched = this.$route.matched.filter(item => item);
      //filte parts
      this.parts = matched;
    },
    adjustContentMinHeight() {
      var height = window.innerHeight - headerAndFootUsedHeight;
      // $(".account-component #innerContent-account").css("height", (height < 0 ? 0 : height) + "px");
    },
    getLeftHeightWithoutFootAndHeader() {
      return window.innerHeight - headerAndFootUsedHeight;
    }
  },
  created() {
    var self = this;
    $(window).resize(() => {
      self.adjustContentMinHeight();
    });
    $(function() {
      self.adjustContentMinHeight();
    });
    this.getLocationParts();
  },
  mounted() {
    $("#filler").remove();
  }
};
</script>

<style>

#account-contentWrapper .title-p {
  margin: 0px;
  margin-left: 20px;
  float: left;
  padding: 0px;
  background-image: url(../../static/images/logo-ai.png);
  background-position-y: center;
  background-repeat: no-repeat;
  background-size: 95px;
  font-weight: bold;
  color: white;
  padding-left: 105px;
  line-height: 61px;
  font-size: 18px;
}
</style>
